import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/modernization-playbook/modernization-playbook/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Code`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/garage/architectures/modern-integration"
        }}>{`Modern Integration the IBM Garage Perspective`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://ibm-cloud-architecture.github.io/refarch-eda/"
        }}>{`Event Driven Architecture - eBook`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.ibm.com/integration/blog/2019/10/15/storing-encrypted-security-credentials-in-a-vault-using-app-connect-enterprise-v11-0-0-6/"
        }}>{`Storing Encrypted Secuirty Credentials in a Vault using ACE v11.0.0.6`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ot4i/ace-docker"
        }}>{`IBM ACE on GitHub`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://hub.docker.com/r/ibmcom/mq/"
        }}>{`MQ Advanced for Developers on Docker`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ibm-messaging/mq-container/blob/master/docs/building.md#building-a-production-image"
        }}>{`Building an MQ Container`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ibm-messaging/mq-container/blob/master/docs/internals.md#prometheus-metrics"
        }}>{`Providing MQ Stats to Prometheus`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ibm-cloud-architecture/refarch-integration-api"
        }}>{`APIC Connect Content for the Inventory API definition and management`}</a></li>
    </ul>
    <h3>{`How-To Guides`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.ibm.com/integration/docs/app-connect-enterprise/videos-for-ibm-app-connect-enterprise/#"
        }}>{`Creating a message Flow in ACE`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.ibm.com/integration/docs/app-connect-enterprise/videos-for-ibm-app-connect-enterprise/#"
        }}>{`Getting Started with ACE`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.ibm.com/integration/docs/app-connect-enterprise/videos-for-ibm-app-connect-enterprise/#"
        }}>{`How to Use Policies in ACE`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.ibm.com/integration/docs/app-connect-enterprise/videos-for-ibm-app-connect-enterprise/#"
        }}>{`ACE Admin Security - UserID / Password`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.ibm.com/integration/docs/app-connect-enterprise/videos-for-ibm-app-connect-enterprise/#"
        }}>{`ACE Admin Security - HTTPS`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.ibm.com/aspera/"
        }}>{`Aspera Developer Community`}</a></li>
    </ul>
    <h3>{`Reference architectures`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/garage/architectures/modern-integration/reference-architecture"
        }}>{`Modern Integration Reference Architecture`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/garage/architectures/apiArchitecture"
        }}>{`Digital Transformation Through APIs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/garage/architectures/apiArchitecture/reference-architecture"
        }}>{`API Reference Architecture`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/cloud-pak-for-integration"
        }}>{`IBM Cloud Pak for Integration`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/garage/architectures/cloud-pak-for-integration-runtime-solution"
        }}>{`IBM Cloud Pak for Integration: Runtime`}</a></li>
    </ul>
    <h3>{`Tutorials`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/downloads/cas/J7E0VLDY"
        }}>{`Agile Integration Architecture - eBook`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://pages.github.ibm.com/CASE/cloudpak-onboard-residency/integration/introduction/"
        }}>{`IBM Cloud Pak for Integration Playbook`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/developerworks/library/wa-get-started-with-loopback-neward-1/index.html?cm_sp=developer-_-apic-dev-center-_-view-guide"
        }}>{`Build LoopBack API with APIC & Node.js`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.ibm.com/patterns/unlock-enterprise-data-using-apis/?cm_sp=developer-_-apic-dev-center-_-journey-landing-page"
        }}>{`Unlock Enterprise Data Using APIs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ibm-datapower/datapower-tutorials"
        }}>{`DataPower Tutorials`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.ibm.com/integration/docs/app-connect/tutorials-for-ibm-app-connect/"
        }}>{`App Connect Tutorials`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.ibm.com/messaging/learn-mq/mq-tutorials/"
        }}>{`MQ Tutorials from IBM Developer`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/garage/tutorials/manage-api-lifecycle"
        }}>{`Automate API lifecycle management by using a DevOps platform`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/garage/tutorials/ibm-mq-on-cloud/tutorial-mq-on-ibm-cloud"
        }}>{`Tutorial - MQ on IBM Cloud`}</a></li>
    </ul>
    <h3>{`Webinars`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/garage/videos/efficient-api-deployment-with-devops-governance"
        }}>{`Realizing the Economic Value of APIs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/app-connect"
        }}>{`ACE - IBM App Connect at IBM`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/api-connect"
        }}>{`API Connect at IBM`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/products/datapower-gateway"
        }}>{`DataPower Gateways at IBM`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/products/mq"
        }}>{`MQ at IBM`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/high-speed-data-transfer"
        }}>{`Aspara at IBM`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.ibm.com/apiconnect/resources/category/webinars/"
        }}>{`Several APIC Related Webinars`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.ibm.com/datapower/videos/"
        }}>{`DataPower Webinars`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.youtube.com/playlist?list=PLzpeuWUENMK2Q77xr7QkvLxU5YxOJxVSH"
        }}>{`App Connect Channel on YouTube - Extensive List of Videos`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=z3rcNn2u-LI&list=PLOspHqNVtKAB_rIzQs9tokpQWN8KAHryK"
        }}>{`Aspera YouTube Channel`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      